export default __webpack_public_path__ + "static/media/target.74b4f6b5.png";